export const formatReceiptNumber = (number: number) => {
    return number.toString().padStart(6, '0'); // Adds leading zeros to make it at least 4 digits
}